module.exports = "<div class=\"gw-clearfix\">\r\n    <div class=\"span12 mb10\" ng-show=\"previous\">\r\n        <button class=\"gw-btn-primary\" ng-click=\"goToPrevious()\">\r\n            <i class=\"fa fa-chevron-left\"></i>\r\n            {{getPreviousLabel()}}\r\n        </button>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/navigation/templates/back-button-navigation.html
// module id = 552
// module chunks = 0